module.exports = __webpack_public_path__ + "static/media/grid7.1fd1b96d.jpg";